// Most of our list/detail modules (Contact, Artwork, Instance, etc.) mount a
// single Formik instance for the whole module. That means `selected.ids` and
// other list-side state (`select`, `search`, `listId`, image-list ids, …)
// silently survive when the user navigates from the list into a detail page.
// Bulk actions in `PrimaryNav` (Handover, Update CRM, Export, Adhoc Report,
// Subscribe, Batch Edit, …) read those leaked values and quietly fan out to
// whatever was last selected on the list — which is how users have ended up
// handing over hundreds of contacts when they meant to touch one.
//
// `scopeBulkActionTargets` centralises the rule:
//   * list page (no `entityId`)        -> forward the user's selection and
//                                         every list-side filter unchanged.
//   * detail page (has `entityId`)     -> ignore everything from formik and
//                                         force the action to act on exactly
//                                         the entity in the URL. Every
//                                         `fallback` field is nulled out so
//                                         downstream consumers can't rebuild
//                                         a list-wide query from the leaked
//                                         state.
//   * malformed `entityId` (NaN-like)  -> return `[]` so we never send
//                                         `[NaN]` / `[0]` to the API.
//
// `fallbacks` is intentionally a free-form object: each module passes the
// list-side fields it actually uses (search, listId, select, imageListId,
// workingListId, imageWorkingListId, …) and the helper clears every key it
// receives. This avoids hard-coding module-specific knowledge into the util.
const scopeBulkActionTargets = ({
  entityId,
  selectedIds = [],
  fallbacks = {},
} = {}) => {
  const isDetailPage = entityId != null && entityId !== "";

  if (isDetailPage) {
    const numericEntityId = +entityId;
    const clearedFallbacks = Object.keys(fallbacks).reduce(
      (accumulator, key) => ({ ...accumulator, [key]: null }),
      {},
    );
    return {
      ids: Number.isFinite(numericEntityId) ? [numericEntityId] : [],
      ...clearedFallbacks,
    };
  }

  return {
    ids: Array.isArray(selectedIds) ? selectedIds : [],
    ...fallbacks,
  };
};

export { scopeBulkActionTargets };
